<template>
  <div :class="classes">
    <div v-for="(group, index) in groups" :key="index" class="tag-group-field__groups">
      <m4-heading level="4" v-if="group.title">{{ group.title }}</m4-heading>
      <div class="tag-group-field__items">
        <div
          v-for="(item, j) in group.items"
          @click="select(item)"
          :key="j"
          :class="itemClasses(item)"
          :title="item.disabled ? 'occupied' : ''"
        >
          {{ item.label }}
        </div>
      </div>
    </div>
    <input type="hidden" :name="$attrs.name" :value="newValue" />
  </div>
</template>

<script>
export default {
  name: "M4TagGroupField",
  data() {
    return {
      newValue: this.modelValue ? this.modelValue : this.value
    };
  },
  props: {
    value: String,
    modelValue: String,
    groups: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  computed: {
    classes() {
      let classes = ["tag-group-field"];
      return classes;
    }
  },
  methods: {
    itemClasses(item) {
      let classes = ["tag-group-field__items__item"];
      if (item.disabled) {
        classes.push("tag-group-field__items__item--disabled");
      } else {
        classes.push("tag-group-field__items__item--active");
      }

      if (item.value + "" === this.newValue + "") {
        classes.push("tag-group-field__items__item--selected");
      }

      return classes;
    },
    select(item) {
      if (item.disabled) {
        return false;
      }
      if (this.newValue + "" !== item.value + "") {
        this.newValue = item.value;
      } else {
        this.newValue = null;
      }
    }
  }
};
</script>
